module.exports = __webpack_public_path__ + "assets/favicon-bf-be.a7bb3ff4.png";